/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export enum AttributeNames {
  EXPRESS_TYPE = 'express.type',
  EXPRESS_NAME = 'express.name',
}
